import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { RxCopyFromToothMenuComponent } from '@modules/rx-intuitive-copy-from-tooth/components/rx-copy-from-tooth-menu/rx-copy-from-tooth-menu.component';
import { RxIntuitiveCopyFromBehaviorService } from '@modules/rx-intuitive-teeth-orchestrator/services/rx-intuitive-copy-from-behavior.service';
import { RxIntuitiveIndicationMapperService } from '@modules/rx-intuitive-teeth-orchestrator/services/rx-intuitive-indication-mapper.service';
import { RxIntuitiveTeethDiagramMutationService } from '@modules/rx-intuitive-teeth-orchestrator/services/teeth-diagram/rx-intuitive-teeth-diagram-mutation.service';
import {
	OrchestratorViewMode,
	OrchestratorViewModeType
} from '@modules/rx-intuitive-teeth-orchestrator/state/rx-intuitive-teeth-orchestrator-store';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
	selector: 'rx-intuitive-treatment-toolbar',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, RxCopyFromToothMenuComponent, TlkButtonComponent],
	templateUrl: './rx-intuitive-treatment-toolbar.component.html',
	styleUrls: ['./rx-intuitive-treatment-toolbar.component.scss']
})
export class RxIntuitiveTreatmentToolbarComponent {
	@Input() showCopyFromToothMenu: boolean;
	@Input() currentOrchestratorViewMode: OrchestratorViewModeType;
	@Input() tableViewDisabled = false;
	@Output() viewModeSwitched = new EventEmitter<OrchestratorViewModeType>();

	readonly orchestratorViewMode = OrchestratorViewMode;

	readonly copyFromMenuDefaultIndicationId: number;
	readonly copyFromSourceMenuItems$ = this.copyFromBehaviorService.copyFromSourceMenuItems$;
	readonly isCopyFromToothControlDisabled$ = this.copyFromBehaviorService.isCopyFromMenuEnabled$.pipe(map(enabled => !enabled));

	constructor(
		private readonly copyFromBehaviorService: RxIntuitiveCopyFromBehaviorService,
		private readonly mutationService: RxIntuitiveTeethDiagramMutationService,
		private readonly indicationMapper: RxIntuitiveIndicationMapperService
	) {
		this.copyFromMenuDefaultIndicationId = this.indicationMapper.getDefaultIndication();
	}

	switchViewMode(newViewMode: OrchestratorViewModeType) {
		this.viewModeSwitched.emit(newViewMode);
	}

	onCopyFromToothSourceSelected(toothId: number): void {
		this.mutationService.copyTreatmentDetailsFromSourceTooth(toothId);
	}
}
